import { render } from "./NavHeader.vue?vue&type=template&id=a9f5147c&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=a9f5147c&lang=scss&scoped=true"

import exportComponent from "D:\\Spadej Work\\SPJWEB\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f5147c"]])

export default __exports__